import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => ({
	backButton: {
		boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
		transition: "all 0.2s ease-in-out",
		"&:hover": {
			backgroundColor: "rgba(255, 255, 255, 1)",
			transform: "scale(1.05)",
		},
		"&:active": {
			transform: "scale(0.95)",
		},
		height: "32px",
		width: "32px",
	},
}));


